"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueFromStringProviderSync = exports.getValueFromStringProvider = void 0;
const tslib_1 = require("tslib");
function getValueFromStringProvider(provider) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (typeof provider === "string")
            return provider;
        if (typeof provider === "function")
            return provider();
        return undefined;
    });
}
exports.getValueFromStringProvider = getValueFromStringProvider;
function getValueFromStringProviderSync(provider) {
    if (typeof provider === "string")
        return provider;
    if (typeof provider === "function")
        return provider();
    return undefined;
}
exports.getValueFromStringProviderSync = getValueFromStringProviderSync;
